<template>
  <div v-loading="showFlag">
    <!--  赤伝票出力確認画面 -->
    <t-card>
      <div :style="{ height: basicHeight + 'px' }">
        <t-form>
          <t-row>
            <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
              >&nbsp;</t-col
            >
            <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_SEVENTEEN'))"
              >&nbsp;</t-col
            >
            <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_SIX'))"
              class="right"
            >
              <!-- 赤伝票出力 -->
              <t-button
                round
                type="primary"
                class="dialogButton_180_40"
                @click="outPutClick()"
              >
                <i class="el-icon-s-order"></i>
                {{ $t("resource.SEND.RED_DATE_OUTPUT") }}
              </t-button>
            </t-col>
          </t-row>
        </t-form>
      </div>
      <div>
        <t-row class="marginBottom">
          <t-col :span="24">
            <!-- テーブル -->
            <div>
              <t-table
                ref="sendErrorOutputTable"
                :data="sendErrorOutputTable"
                class="table_common"
                header-cell-class-name="bg-default"
                :height="detailHeight"
                highlight-current-row
                :row-class-name="rowClassName"
                :cell-class-name="tableCellClassName"
                border
                fit
              >
                <!-- テーブルの列 -->
                <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="column.overflowTooltip"
                >
                  <template slot-scope="scope">
                    <t-input-number
                      v-if="editableColumns.includes(column.prop)"
                      class="cell_input_number"
                      :controls="false"
                      :precision="0"
                      :min="0"
                      :max="999999"
                      v-model="scope.row[column.prop]"
                      @change="changeCellData()"
                    ></t-input-number>
                    <span v-else>
                      {{ scope.row[column.prop] }}
                    </span>
                  </template>
                </t-table-column>
              </t-table>
            </div>
          </t-col>
        </t-row>
      </div>

      <div :style="{ height: bottomHeight + 'px' }">
        <t-form label-position="right">
          <t-row type="flex" justify="end">
            <div>
              <t-col :span="24">
                <t-button
                  round
                  type="warning"
                  class="dialogButton_confirm_120_40"
                  @click="confirmClick"
                >
                  <i class="el-icon-check"></i>
                  {{ $t("resource.sys.sure") }}</t-button
                >
              </t-col>
            </div>
          </t-row>
        </t-form>
      </div>
    </t-card>
  </div>
</template>
<script>
import { getUserInfo } from "@/auth";
import { t } from "@/locales";
import {
  getAcceptOrderAndOrderDetail,
  saveSendErrorData,
} from "@/services/send";
import {
  formatCurrencyToNumber,
  getDialogContentHeight,
} from "@/utils/comFunction";
import {
  DIALOG_LINE_HEIGHT,
  NUM_ZERO,
  STR_ONE,
  STR_TWO,
  STR_ZERO,
} from "@/utils/const";
import { setColumnWidth } from "@/utils/table";
import { Message } from "@tellus/component";
export default {
  data() {
    return {
      editableColumns: ["sdProdSuppPayQty"],
      //出荷異常情報
      sendErrorOutputTable: [
        {
          sdQuoteNo: "", // 見積No
          sdProdNo: "", // 受注明細No
          aodCusDeliveryDate: "", //得意先納期.
          aodProdName: "", // 品名
          aodProdDrawNo: "", // 図番,
          sdDeliveryNgQty: "", //出荷NG数
          sdUSalesPrice: "", //売価
          sdProdExQty: "", //異常件数
          sdProdCloseQty: "", //クローズ件数
          sdProdSuppPayQty: "", // 異常支払数
          sdOrderNo: "", //注文No
          sdDetailNo: "", //注文明細No
          sdProdSuppPayQty: "", //補足支払数
        },
      ],
      sendEditForm: this.sendEditData,
      saveAcceptOrderForm: [],
      saveOrderDetailForm: [],
      sendDetailData: [],
      acceptOrderDetailForm: [],
      orderDetailForm: [],

      //注文明細データ
      orderDetailForm: [],
      //最大高さ
      maxheight: 260,

      //テーブルの列
      columns: [
        {
          // 見積No.
          prop: "sdQuoteNo",
          label: t("resource.SEND.ESTIMATED_NO"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 得意先納期
        {
          prop: "aodCusDeliveryDate",
          label: t("resource.SEND.CUS_DELIVERY_DATE"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
        },
        // 品名
        {
          prop: "aodProdName",
          label: t("resource.SEND.PRODUCT_NAME"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 図番
        {
          prop: "aodProdDrawNo",
          label: t("resource.SEND.PRODUCT_DRAW_NO"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 出荷NG数
        {
          prop: "sdDeliveryNgQty",
          label: t("resource.SEND.SEND_NG_COUNT"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },
        // 売価
        {
          prop: "sdUSalesPrice",
          label: t("resource.SEND.SALES_PRICE"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },

        // 異常件数
        {
          prop: "sdProdExQty",
          label: t("resource.SEND.EXCEPT_QTY"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },
        // クローズ件数
        {
          prop: "sdProdCloseQty",
          label: t("resource.SEND.PRODUCT_CLOSE_QTY"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
          overflowTooltip: true,
        },
        // 異常支払数
        {
          prop: "sdProdSuppPayQty",
          label: t("resource.SEND.ERROR_PAY_QTY"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
        },
      ],

      //現在選択されているセル
      currentCell: null,

      data: null,

      // 異常区分
      prodExKbnList: [],

      showFlag: false,

      //基本情報のheight
      basicHeight: DIALOG_LINE_HEIGHT * 1,
      //明細情報のheight 20:Tableと合計行の間隔調整用(Table的marginTop + bottom)
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 1,
        DIALOG_LINE_HEIGHT * 1,
        20
      ),
      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,
    };
  },

  props: {
    selectData: {
      Type: Object,
      default: null,
    },
    sendEditData: {
      Type: Object,
      default: null,
    },
  },

  mounted() {
    this.init(this.selectData);

    //列幅に自動調整
    setColumnWidth(this.columns, this.sendErrorOutputTable);

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    handleResize() {
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 1,
        DIALOG_LINE_HEIGHT * 1,
        20
      );
    },

    // 初期化
    init(data) {
      this.sendErrorOutputTable = data;
      this.getOrderDetailForm();

      //列幅に自動調整
      setColumnWidth(this.columns, this.sendErrorOutputTable);
    },

    //确定ボタン
    confirmClick() {
      if (this.sendErrorOutputTable) {
        // 異常支払数のチェック
        if (this.checkAllDeliveryNgQtyEmpty(this.sendErrorOutputTable)) {
          Message.showError(t("message.SEND.NO_PAY_QTY_CHECK"), null);
          return;
        }
        this.dataAddUpdProc();
        this.saveOrderDataProcess();
        this.saveAcceptOrderDataProcess();
        saveSendErrorData({
          sendDetailList: this.sendDetailData,
          sendBasicForm: this.sendEditForm,
          acceptOrderDetailList: this.saveAcceptOrderForm,
          orderDetailList: this.saveOrderDetailForm,
        })
          .then((res) => {
            Message.showSuccess(t("message.SEND.UPDATE_SUCCESS"));
          })
          .catch((err) => {
            Message.showError(
              t("message.SEND." + err.data.Messages[0].Message),
              null
            );
          });
      }
      this.$emit("ok");
    },

    // 更新されたデータ処理
    dataAddUpdProc() {
      // console.log("this.sendEditForm = " + JSON.stringify(this.sendEditForm));
      // console.log(
      //   "this.sendErrorOutputTable = " +
      //     JSON.stringify(this.sendErrorOutputTable)
      // );

      this.sendDetailData = [];

      for (let index = 0; index < this.sendErrorOutputTable.length; index++) {
        const element = this.sendErrorOutputTable[index];
        // 小計
        var sdTotalSales = "";
        if (element.sdTotalSales == "-") {
          sdTotalSales = 0;
        } else {
          sdTotalSales = formatCurrencyToNumber(element.sdTotalSales);
        }
        this.sendDetailData.push({
          sdSendNo: this.sendEditForm.sbSendNo, // 出荷No.
          sdSendDetailNo: index + 1, // 出荷明細No.
          sdSendQty: element.sdSendQty, // 出荷数量
          sdUSalesPrice: formatCurrencyToNumber(element.sdUSalesPrice), // 売価
          sdTotalSales: sdTotalSales, // 小計

          sdDeliveryNoteOut: element.sdDeliveryNoteOut, //納品書出力 0：チェックしない　1：チェックする
          sdDeliveryNgQty: this.checkNull(element.sdDeliveryNgQty), //納品NG数
          sdRemarks: element.sdRemarks, //備考
          sdProdExKbn: this.checkNull(element.sdProdExKbn), // 製品異常区分
          sdProdExQty: this.checkNull(element.sdProdExQty), //異常件数
          sdProdCloseQty: this.checkNull(element.sdProdCloseQty), //クローズ件数

          sdProdSuppPayQty: this.checkNull(element.sdProdSuppPayQty), //補足支払数.
          sdCloseState: element.sdCloseState ? 1 : 0, // クローズ状態 0：未クローズ、1：クローズ

          sdOrderNo: element.sdOrderNo, // 注文No. 注文基本情報_注文No.
          sdDetailNo: element.sdDetailNo, // 注文明細No. 注文明細_注文明細No.
          sdQuoteNo: element.sdQuoteNo, // 見積No. 受注基本情報_見積No.
          sdProdNo: element.sdProdNo, // 受注明細No. 受注明細_受注明細No.
        });
      }
      // console.log(
      //   "this.sendDetailData = " + JSON.stringify(this.sendDetailData)
      // );
    },

    // 異常支払数のチェック
    checkAllDeliveryNgQtyEmpty(table) {
      let allEmpty = true;
      for (let i = 0; i < table.length; i++) {
        if (
          table[i].sdProdSuppPayQty !== 0 &&
          table[i].sdProdSuppPayQty !== ""
        ) {
          allEmpty = false;
          break;
        }
      }
      return allEmpty;
    },

    //注文明細データの取得
    getOrderDetailForm() {
      getAcceptOrderAndOrderDetail({
        sendDetailList: this.sendErrorOutputTable,
      })
        .then((res) => {
          // console.log("getOrderDetailForm : res = " + JSON.stringify(res));
          this.orderDetailForm = res.orderDetailList;

          this.acceptOrderDetailForm = res.acceptOrderDetailList;
        })
        .catch((err) => {});
    },

    //保存された注文データ処理
    saveOrderDataProcess() {
      // console.log("saveOrderDataProcess start");
      this.saveOrderDetailForm = [];
      for (let index = 0; index < this.sendErrorOutputTable.length; index++) {
        const element = this.sendErrorOutputTable[index];

        for (let j = 0; j < this.orderDetailForm.length; j++) {
          const detailElement = this.orderDetailForm[j];

          if (
            element.sdOrderNo == detailElement.odOrderNo &&
            detailElement.odOrderDetailNo == element.sdDetailNo &&
            element.sdProdExKbn == STR_ZERO
          ) {
            var odProdCloseQty = "";
            if (element.sdCloseState == STR_ONE) {
              odProdCloseQty = element.sdDeliveryNgQty;
            } else {
              // クローズ件数
              odProdCloseQty = 0;
            }

            this.saveOrderDetailForm.push({
              odOrderNo: element.sdOrderNo, // 注文No.
              odOrderDetailNo: element.sdDetailNo, //注文明細No.
              odUPrice: detailElement.odUPrice, //加工単価(CNY)
              odTotal: detailElement.odTotal, //小計
              odProdQuantity: -odProdCloseQty, //数量
              odCurType: detailElement.odCurType, // 貨幣タイプ
              odExr: detailElement.odExr, //レート
              odMaterialCost: detailElement.odMaterialCost, //材料費
              odMachineCost: detailElement.odMachineCost, //加工費
              odProcess1Cost: detailElement.odProcess1Cost, //処理1費用
              odProcess2Cost: detailElement.odProcess2Cost, //処理2費用
              odProcess3Cost: detailElement.odProcess3Cost, //処理3費用
              odProcess4Cost: detailElement.odProcess4Cost, //処理4費用
              odPayStatus: STR_ONE, //支払状態
              odProdExKbn: STR_TWO, //製品異常区分
              odProdExQty: element.sdDeliveryNgQty, //異常件数
              odProdCloseQty: odProdCloseQty, //クローズ件数
              odProdSuppQty: element.sdDeliveryNgQty - odProdCloseQty, //補足件数
              odProdSuppPayQty: NUM_ZERO, //補足支払数
              odCloseState: NUM_ZERO, //クローズ状態
              odQuoteNo: element.sdQuoteNo, //受注基本情報_見積No
              odProdNo: element.sdProdNo, //受注明細_受注明細No
              odUpdateUser: getUserInfo().UserId, //更新者
              odUpdateTime: detailElement.odUpdateTime, //更新時刻
            });
          }
        }
      }
    },

    //保存された受注データ処理
    saveAcceptOrderDataProcess() {
      this.saveAcceptOrderForm = [];
      for (let index = 0; index < this.sendErrorOutputTable.length; index++) {
        const element = this.sendErrorOutputTable[index];

        for (let j = 0; j < this.acceptOrderDetailForm.length; j++) {
          const detailElement = this.acceptOrderDetailForm[j];
          if (
            element.sdQuoteNo == detailElement.aodQuoteNo &&
            detailElement.aodProdNo == element.sdProdNo &&
            element.sdProdExKbn == STR_ZERO
          ) {
            //クローズ件数
            var aodProdCloseQty = "";
            ///受注数量:
            var aodProdQuantity = "";
            if (element.sdCloseState == STR_ONE) {
              aodProdCloseQty = this.saveOrderDetailForm[index].odProdExQty;
              //受注数量: -クローズ件数
              aodProdQuantity = -aodProdCloseQty;
            } else {
              // クローズ件数
              aodProdCloseQty = 0;
              aodProdQuantity = 0;
            }
            this.saveAcceptOrderForm.push({
              aodQuoteNo: element.sdQuoteNo, // 見積No.
              aodProdNo: element.sdProdNo, //受注明細No.
              aodNdProdNo: detailElement.aodNdProdNo, //.
              aodProdName: element.aodProdName,
              aodProdDrawNo: element.aodProdDrawNo,
              aodProdQuantity: aodProdQuantity, //受注数量
              aodProdUnit: element.aodProdUnit,
              aodProdMaterial: detailElement.aodProdMaterial,
              aodProdTreatment: detailElement.aodProdTreatment,
              aodUWeight: detailElement.aodUWeight,
              aodMSupCode: detailElement.aodMSupCode,
              aodMSupDate: detailElement.aodMSupDate,
              aodMCurType: detailElement.aodMCurType,
              aodMExr: detailElement.aodMExr,
              aodMUPrice: detailElement.aodMUPrice,
              aodMTransportCost: detailElement.aodMTransportCost,
              aodMUTransportCost: detailElement.aodMUTransportCost,
              aodMCommissionRate: detailElement.aodMCommissionRate,
              aodMUCommission: detailElement.aodMUCommission,
              aodMUPurchasePrice: detailElement.aodMUPurchasePrice,

              aodP1SupCode: detailElement.aodP1SupCode,
              aodP1SupDate: detailElement.aodP1SupDate,
              aodP1CurType: detailElement.aodP1CurType,
              aodP1Exr: detailElement.aodP1Exr,
              aodP1UPrice: detailElement.aodP1UPrice,
              aodP1TransportCost: detailElement.aodP1TransportCost,
              aodP1UTransportCost: detailElement.aodP1UTransportCost,
              aodP1CommissionRate: detailElement.aodP1CommissionRate,
              aodP1UCommission: detailElement.aodP1UCommission,
              aodP1UPurchasePrice: detailElement.aodP1UPurchasePrice,

              aodP2SupCode: detailElement.aodP2SupCode,
              aodP2SupDate: detailElement.aodP2SupDate,
              aodP2CurType: detailElement.aodP2CurType,
              aodP2Exr: detailElement.aodP2Exr,
              aodP2UPrice: detailElement.aodP2UPrice,
              aodP2TransportCost: detailElement.aodP2TransportCost,
              aodP2UTransportCost: detailElement.aodP2UTransportCost,
              aodP2CommissionRate: detailElement.aodP2CommissionRate,
              aodP2UCommission: detailElement.aodP2UCommission,
              aodP2UPurchasePrice: detailElement.aodP2UPurchasePrice,

              aodP3SupCode: detailElement.aodP3SupCode,
              aodP3SupDate: detailElement.aodP3SupDate,
              aodP3CurType: detailElement.aodP3CurType,
              aodP3Exr: detailElement.aodP3Exr,
              aodP3UPrice: detailElement.aodP3UPrice,
              aodP3TransportCost: detailElement.aodP3TransportCost,
              aodP3UTransportCost: detailElement.aodP3UTransportCost,
              aodP3CommissionRate: detailElement.aodP3CommissionRate,
              aodP3UCommission: detailElement.aodP3UCommission,
              aodP3UPurchasePrice: detailElement.aodP3UPurchasePrice,

              aodGrossMargin: detailElement.aodGrossMargin,
              aodUSalesPrice: detailElement.aodUSalesPrice,
              aodUSetPrice: detailElement.aodUSetPrice,
              aodUGrossProfit: detailElement.aodUGrossProfit,
              aodTotPurchasePrice: detailElement.aodTotPurchasePrice,
              aodTotSalesPrice: detailElement.aodTotSalesPrice,
              aodTotWeight: detailElement.aodTotWeight,
              aodProdExKbn: STR_TWO,
              aodProdExQty: element.sdDeliveryNgQty,
              aodProdCloseQty: aodProdCloseQty,
              aodProdSuppQty: element.sdDeliveryNgQty - aodProdCloseQty, //補足件数: 異常件数-クローズ件数
              aodCloseState: NUM_ZERO,
              aodUpdateUser: getUserInfo().UserId,
              aodUpdateTime: detailElement.aodUpdateTime,
            });
          }
        }
      }
      // console.log(
      //   "saveDataProcess this.saveAcceptOrderForm = " +
      //     JSON.stringify(this.saveAcceptOrderForm)
      // );
    },

    checkNull(val) {
      if (!!!val || val == "") {
        val = 0;
      }
      return val;
    },

    //セルデータの保存
    changeCellData() {
      this.currentCell = null;

      setColumnWidth(this.columns, this.sendDetailTable);
    },

    //セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;

      var columnEditable = ["sdProdSuppPayQty"];

      if (
        columnEditable.includes(column.property) ||
        (column.property && column.property.toString().includes("newColumn"))
      ) {
        //編集可能の背景色
        return "bg-cell-editable";
      }
    },

    // 製品異常
    rowClassName({ row }) {
      if (!!row.sdProdExKbn && row.sdProdExKbn != "") {
        if (row.sdProdExKbn == STR_TWO) {
          return "textColor";
        }
      }
    },
    //出力
    outPutClick() {
      this.$message("「赤伝票出力」ボタン");
    },

    close() {
      this.$emit("cancel");
    },
  },
};
</script>
<style scoped>
</style>
